import { render, staticRenderFns } from "./formFour.vue?vue&type=template&id=05100c00&scoped=true&"
import script from "./formFour.vue?vue&type=script&lang=js&"
export * from "./formFour.vue?vue&type=script&lang=js&"
import style0 from "./formFour.vue?vue&type=style&index=0&id=05100c00&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05100c00",
  null
  
)

export default component.exports